/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@panel/commons/hooks';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useHistory, useLocation } from 'react-router-dom';
import { Title, TextInfo, FieldError } from '../../styles';
import { InputField } from './fields';
import { selectEcommerceUser, selectProductTaxesParams } from '../../../../../ducks/step4Module2';
import { Step4Module3Selectors } from '../../../../../ducks/step4Module3';
import { usePublisherRedirection } from '../../../../../hooks/usePublisherRedirection';

function PhoneForm() {
  const { productId } = useSelector(selectProductTaxesParams);
  const ecommerceUser = useSelector(selectEcommerceUser);
  const { contactInfo } = useSelector(Step4Module3Selectors.getPostingPreviewInfo);
  const { handleSubmit, getValues, reset } = useFormContext();
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const { push } = useHistory();
  const { t } = useTranslation();

  usePublisherRedirection(!productId, '/planes/seleccion');

  useEffect(() => {
    if (contactInfo && ecommerceUser) {
      const { phone, mobilPhone } = ecommerceUser;
      const phoneNumber = contactInfo.phone
        .map(p => p.phone)
        .concat([phone, mobilPhone])
        .find(p => /.*\d.*/.test(p));
      reset({ phoneNumber });
    }
  }, [ecommerceUser, contactInfo, reset]);

  const onSubmit = () => {
    push({
      pathname: '/publicador/planes/pago/exito',
      search: `?postingId=${postingId}`,
      state: { phoneNumber: getValues('phoneNumber') }
    });
  };

  return (
    <form id='step4Module2FormContact' onSubmit={handleSubmit(onSubmit)} name='phoneContact' noValidate>
      <Title secondary>{t('publisher.step4.module2.contactForm.title')}</Title>
      <Title subtitle>{t('publisher.step4.module2.contactForm.subtitle')}</Title>
      <InputField
        name='phoneNumber'
        renderError={errorProps => (
          <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
        )}
      />
      <TextInfo>
        {t('publisher.step4.module2.contactForm.text.part1')}
        <b>{t('publisher.step4.module2.contactForm.number')}</b>
        {t('publisher.step4.module2.contactForm.text.part2')}
      </TextInfo>
    </form>
  );
}

export default PhoneForm;
